import React, { useRef, useState } from "react";
import { useNotifications } from "./NotificationContext";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import axios from "axios";
import { useHistory } from "react-router-dom";

const formatPaymentPlan = (plan) => {
  const value = String(plan || "").toLowerCase();
  switch (value) {
    case "one-time":
      return "Jährlich";
    case "quarterly":
      return "Quartalsweise";
    case "annual":
      return "Jährlich";
    case "monthly":
      return "Monatlich";
    default:
      return plan || "–";
  }
};

const getInvoiceReminderTitle = (notification) => {
  const plan = String(notification.payment_plan || "").toLowerCase();
  const stageNumber = Number(notification.stage);
  const stageLabel =
    Number.isFinite(stageNumber) && stageNumber > 0
      ? `${stageNumber}. Erinnerung`
      : "Erinnerung";

  if (plan.includes("quarter")) {
    return `Quartalsrechnung – ${stageLabel}`;
  }
  return `Rechnung – ${stageLabel}`;
};

function NotificationDropdown() {
  const { notifications, fetchNotifications } = useNotifications();
  const dropdownRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(600); // default value
  const history = useHistory();
console.log(notifications)
  const handleNotificationClick = async (notification) => {
    await axios.post("/api2/updateNotificationStatus", {
      job_id: notification.job_id,
      app_id: notification.app_id,
      applyjob_id: notification.applyjob_id,
      subscription_id: notification.subscription_id,
      invoice_reminder_id: notification.invoice_reminder_id ?? notification.id,
      id: notification.id,
      k_user_id: notification.k_user_id,
      user_id: notification.user_id,
      type: notification.type,
    });
    // Fetch the notifications again
    fetchNotifications();
  };

  // Function to get the appropriate URL based on notification type
  const getNotificationLink = (notification) => {
    switch (notification.type) {
      case "new_job":
        return `/admin/job-profile-new/${notification.job_id}`;
      case "deactivated_job":
        return `/admin/job-profile-new/${notification.job_id}`;
      case "new_comment":
        return `/admin/candidate_status?status=${notification.status}&appid=${notification.app_id}&jobid=${notification.job_id}&recipient=${notification.recipient_type}`;
      case "new_invited_person":
        return `/admin/institution-list-new`;
      case "new_company":
        return `/admin/institution-details/${notification.hosp_id}`;
      case "candidate_message":
        return `/admin/messages/${notification.user_id}`;
      case "hospital_message":
        return `/admin/hospital_chat/${notification.user_id}`;
      case "new_subscription":
        return `/admin/hospital-subscriptions`;
      case "subscription_contract_signed":
        return `/admin/hospital-subscriptions`;
      case "invoice_reminder":
        return `/admin/hospital-subscriptions`;
      case "hospital_contract_signed":
        return `/admin/institution-details/${notification.hosp_id}`;
      default:
        // Default to job application link
        return `/admin/job-profile-new/${notification.job_id}`;
    }
  };

  // Function to render notification content based on type
  const renderNotificationContent = (notification) => {
    switch (notification.type) {
      case "new_job":
        return (
          <>
            <b>Neue Job:</b> <br />
            <small>{notification.company_name}</small> <br />
            <small>
              {notification.job_function} (M/W/D) {notification.profession}
            </small>
          </>
        );
      case "deactivated_job":
        return (
          <>
            <b>Deaktiv Job:</b> <br />
            <small>{notification.company_name} - </small> <br />
            <small>
              {notification.job_function} (M/W/D) {notification.profession}
            </small>
          </>
        );
      case "new_comment":
        return (
          <>
            {notification.author_type === "company" ? (
              <>
                <b>Neue Notiz:(Unternehmen)</b> <br />
                <small>Job-ID: {notification.job_id}</small> <br />
                <small>
                  {notification.job_function} (M/W/D) {notification.profession}
                </small>{" "}
                <br />
                <small>
                  Kandidat: {notification.f_name} {notification.l_name}
                </small>{" "}
                <br />
                <small>unternehmen: {notification.company_name}</small> <br />
              </>
            ) : (
              <>
                <b>Neue Notiz:(Kandidat)</b> <br />
                <small>Job-ID: {notification.job_id}</small> <br />
                <small>
                  {notification.job_function} (M/W/D) {notification.profession}
                </small>{" "}
                <br />
                <small>
                  Kandidat: {notification.f_name} {notification.l_name}
                </small>{" "}
                <br />
                <small>unternehmen: {notification.company_name}</small> <br />
              </>
            )}
          </>
        );
      case "new_invited_person":
        return (
          <>
            <b>Kollege wurde eingeladen</b> <br />
            <small>
              Eingeladen durch: {notification.adminDetails.f_name}{" "}
              {notification.adminDetails.l_name}
            </small>{" "}
            <br />
            <small>
              Geladener Kollege: {notification.k_fname} {notification.k_lname}
            </small>{" "}
            <br />
            <small>
              unternehmen: {notification.adminDetails.company_name}
            </small>{" "}
            <br />
          </>
        );
      case "new_company":
        return (
          <>
            <b>Registrierung Unternehmen</b> <br />
            <small>
              Name: {notification.f_name} {notification.l_name}
            </small>{" "}
            <br />
            <small>Telephone: {notification.telephone}</small> <br />
            <small>Unternehmen: {notification.hosp_name}</small> <br />
          </>
        );
      case "candidate_message":
        return (
          <>
            <b>Neue Nachricht vom Kandidaten:</b> <br />
            <small>{notification.f_name} {notification.l_name}</small> <br />
            <small>{notification.message}</small> <br />
            <small>Gesendet am: {new Date(notification.timestamp).toLocaleString()}</small>
          </>
        );
        case "hospital_message":
            return (
              <>
                <b>Neue Nachricht vom Unternehmen:</b> <br />
                <small>{notification.f_name} {notification.l_name}</small> <br />
                <small>{notification.message}</small> <br />
                <small>Gesendet am: {new Date(notification.timestamp).toLocaleString()}</small>
              </>
            );
      case "hospital_contract_signed":
        return (
          <>
            <b>Vertrag unterschrieben</b> <br />
            <small>Unternehmen: {notification.hosp_name}</small> <br />
            <small>
              Ansprechpartner: {notification.f_name} {notification.l_name}
            </small>{" "}
            <br />
            {notification.hosp_sign_date && (
              <small>
                Signiert am:{" "}
                {new Date(notification.hosp_sign_date).toLocaleDateString(
                  "de-DE"
                )}
              </small>
            )}
          </>
        );
      case "new_subscription":
        return (
          <>
            <b>Neues Abonnement</b> <br />
            <small>Subscription ID: {notification.subscription_id}</small>{" "}
            <br />
            {notification.order_number && (
              <>
                <small>
                  Order / Bestellnummer: {notification.order_number}
                </small>{" "}
                <br />
              </>
            )}
            <small>Typ: {notification.subscription_type}</small> <br />
            <small>
              Zahlungsplan:{" "}
              {notification.payment_plan === "one-time"
                ? "Jährlich"
                : notification.payment_plan === "quarterly"
                ? "Quartalsweise"
                : notification.payment_plan === "annual"
                ? "Jährlich"
                : notification.payment_plan === "monthly"
                ? "Monatlich"
                : notification.payment_plan}
            </small>{" "}
            <br />
            <small>Hospital: {notification.hosp_name}</small>
          </>
        );
      case "subscription_contract_signed":
        return (
          <>
            <b>Abonnementvertrag unterschrieben</b> <br />
            <small>Subscription ID: {notification.subscription_id}</small>{" "}
            <br />
            {notification.order_number && (
              <>
                <small>
                  Order / Bestellnummer: {notification.order_number}
                </small>{" "}
                <br />
              </>
            )}
            <small>Typ: {notification.subscription_type}</small> <br />
            <small>
              Zahlungsplan: {formatPaymentPlan(notification.payment_plan)}
            </small>{" "}
            <br />
            <small>Hospital: {notification.hosp_name}</small> <br />
            {notification.contract_signed_date && (
              <small>
                Signiert am:{" "}
                {new Date(notification.contract_signed_date).toLocaleDateString(
                  "de-DE"
                )}
              </small>
            )}
          </>
        );
      case "invoice_reminder":
        return (
          <>
            <b>{getInvoiceReminderTitle(notification)}</b> <br />
            <small>Rechnungsnummer: {notification.invoice_number}</small>{" "}
            <br />
            {notification.order_number && (
              <>
                <small>
                  Order / Bestellnummer: {notification.order_number}
                </small>{" "}
                <br />
              </>
            )}
            {notification.subscription_type && (
              <>
                <small>Abotyp: {notification.subscription_type}</small> <br />
              </>
            )}
            {notification.payment_plan && (
              <>
                <small>
                  Zahlungsplan: {formatPaymentPlan(notification.payment_plan)}
                </small>{" "}
                <br />
              </>
            )}
            {notification.stage && (
              <>
                <small>Stufe: {notification.stage}</small> <br />
              </>
            )}
            {notification.due_date && (
              <>
                <small>
                  Fällig am:{" "}
                  {new Date(notification.due_date).toLocaleDateString("de-DE")}
                </small>{" "}
                <br />
              </>
            )}
            <small>Hospital: {notification.hosp_name}</small> <br />
            {notification.contact_email && (
              <>
                <small>Kontakt: {notification.contact_email}</small> <br />
              </>
            )}
            {notification.sent_at && (
              <small>
                Gesendet am:{" "}
                {new Date(notification.sent_at).toLocaleString("de-DE")}
              </small>
            )}
          </>
        );
      default:
        // Handle job application notifications
        return (
          <>
            <b>{notification.company_name}</b> <br />
            <small>
              {notification.job_function} (M/W/D) {notification.profession}
            </small>
            <br />
            <small>
              User: {notification.f_name} {notification.l_name}
            </small>{" "}
            <br />
            <small>Status: {notification.candidate_status}</small>
          </>
        );
    }
  };

  // Ensure notifications is an array before attempting to use filter
  const notificationCount = Array.isArray(notifications)
    ? notifications.filter((n) => !n.admin_seen).length
    : 0;

  return (
    <>
      <UncontrolledDropdown nav ref={dropdownRef}>
        <DropdownToggle nav>
          🔔 {notificationCount}
        </DropdownToggle>
        <DropdownMenu
          right
          style={{
            overflowY: "scroll",
            marginLeft: "-178px",
            maxHeight: maxHeight,
            maxWidth: "400px",
          }}>
          {Array.isArray(notifications) &&
            notifications.slice(0, 359).map((notification, index) => (
              <DropdownItem
                key={index}
                onClick={() => {
                  const url = getNotificationLink(notification);
                  history.push(url);
                  handleNotificationClick(notification);
                }}>
                {renderNotificationContent(notification)}
                <hr />
              </DropdownItem>
            ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
}

export default NotificationDropdown;
